import React from "react";

import type { Image } from "@app/scripts/types";

type Props = {
  image: Image;
  mobileImage: Image;
  className?: string;
};

export const ResponsiveImage: React.FC<Props> = ({ image, mobileImage, className }) => (
  <>
    <img src={image.url} alt={image?.alt} className={className + " hide-mobile"} />
    {mobileImage && <img src={mobileImage.url} alt={mobileImage?.alt} className={className + " hide-desktop"} />}
  </>
);
